import {mergeConfigDesktop} from '../../../../theme/app.modules-helper';

const EON_MODULES = [
  {
    name: 'member',
    widgets: {
      default: [
        {
          name: 'member',
          needsAuth: true,
          needsID: true,
          active: {
            default: true,
          },
          visible: {
            default: false,
          },
          sideBar: {
            default: false,
          },
          pullToRefresh: {
            default: false,
          },
          apis: {
            default: [
              'EntitiesResolver',
              'MembersResolver',
              'MemberResolver',
              'EnergyKpiMemberResolver',
              'EconomicsKpiMemberResolver',
            ],
          },
          widgets: {
            default: [
              {
                order: 0,
                className: 'grid-12 mb-6_5',
                type: 'headerWeb',
                id: 'headerWeb',
                data: {
                  label: 'members',
                  breadCrumbs: true,
                  navigation: true,
                  calendar: false,
                  download: false,
                  searchBar: true,
                  profile: true,
                },
                devID: 'zany-penguin',
                devPath: 'member->default->headerWeb',
              },
              {
                order: 1,
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-md-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                isOverview: true,
                icon: 'euro',
                kpiContext: 'economics',
                descriptionCallback: 'MemberBenefits',
                descriptionType: 'dynamic-label',
                description: 'widgets.memberBenefitsCard.description.default',
                devID: 'jazzy-glove',
                devPath: 'member->default->memberBenefitsCard',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                drawerConfig: {
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleSavingsKey:
                    'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
              },
              {
                order: 2,
                className: 'grid-xs-12 grid-md-6 grid-lg-4 px-1 pt-xs-0 pb-xs-0_5 pl-md-0_5 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberEnergyFlowsCard',
                id: 'memberEnergyFlowsCard',
                icon: 'lightning',
                descriptionCallback: 'memberEnergy',
                descriptionType: '[member]label+value',
                isOverview: true,
                description: [
                  {
                    key: 'widgets.memberEnergyFlowsCard.description.default.consumption',
                    value: 'consumption',
                  },
                  {
                    key: 'widgets.memberEnergyFlowsCard.description.default.production',
                    value: 'production',
                  },
                  {
                    key: 'widgets.memberEnergyFlowsCard.description.default.self_consumption',
                    value: 'self_consumption',
                  },
                ],
                devID: 'rambunctious-shoe',
                devPath: 'member->default->memberEnergyFlowsCard',
              },
              {
                order: 3,
                className: 'grid-xs-12 grid-lg-4 p-1pt-lg-0 py-xs-0_5 pl-lg-0_5 pr-lg-1',
                env: 'web',
                type: 'map',
                gradientBorder: false,
                id: 'map',
                context: 'member',
                devID: 'nutty-dog',
                devPath: 'member->default->map',
              },
              {
                order: 4,
                className: 'grid-xs-12 grid-xl-9 p-1 py-lg-0 pr-xl-0_5',
                type: 'paymentsTable',
                id: 'paymentsTable',
                devID: 'waggish-marshmallow',
                devPath: 'member->default->paymentsTable',
                showTable: false
              },
              {
                order: 5,
                className: 'grid-xs-12 grid-xl-3 p-1 pt-xs-0 pb-xs-0 pl-xl-0_5',
                type: 'parametersDetails',
                id: 'parametersDetails',
                items: [
      
              {
                type: 'MemberDetailsParameters',
                id: 'MemberDetailsParameters',
                data: {
                  title: 'widgets.memberDetailsParameters.title',
                  fields: {
                    communityId: 'widgets.memberDetailsParameters.communityId',
                    externalId: 'widgets.memberDetailsParameters.externalId',
                    // communityCode: 'widgets.memberDetailsParameters.communityCode',
                    communityName: 'widgets.memberDetailsParameters.communityName',
                    communityType: 'widgets.memberDetailsParameters.communityType',
                    startDate: 'widgets.memberDetailsParameters.startDate',
                    memberId: 'widgets.memberDetailsParameters.memberId',
                    clientId: 'widgets.memberDetailsParameters.clientId',
                    name: 'widgets.memberDetailsParameters.name',
                    address: 'widgets.memberDetailsParameters.address',
                    city: 'widgets.memberDetailsParameters.city',
                    postcode: 'widgets.memberDetailsParameters.postcode',
                    phone: 'widgets.memberDetailsParameters.phone',
                    email: 'widgets.memberDetailsParameters.email',
                  },
                  sitesNumber: 'widgets.memberDetailsParameters.sitesNumber',
                  shownFields: ['memberId', 'address', 'city', 'phone', 'email'],
                },
                devID: 'glowing-lighthouse',
                devPath: 'member->default->MemberDetailsParameters',
              },
              {
                type: 'memberSitesList',
                id: 'memberSitesList',
                devID: 'golden-pajamas',
                devPath: 'member->default->memberSitesList',
              },
                ]
              }
            ],
          },
        },
        {
          name: 'site',
          needsAuth: true,
          needsID: true,
          active: {
            default: true,
          },
          visible: {
            default: false,
          },
          sideBar: {
            default: false,
          },
          pullToRefresh: {
            default: false,
          },
          apis: {
            default: [
              'EntitiesResolver',
              'SiteOverviewResolver',
              'EnergyKpiSiteResolver',
              'EconomicsKpiSiteResolver',
            ],
          },
          widgets: {
            default: [
              {
                order: 0,
                className: 'grid-12 mb-6_5',
                type: 'headerWeb',
                id: 'headerWeb',
                data: {
                  label: 'site',
                  breadCrumbs: true,
                  navigation: true,
                  calendar: false,
                  download: false,
                  searchBar: true,
                  profile: true,
                },
                devID: 'happy-shoe',
                devPath: 'site->default->headerWeb',
              },
              {
                order: 1,
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pb-xs-0_5 pt-md-0 pr-md-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteBenefitsCard',
                id: 'siteBenefitsCard',
                isOverview: true,
                totalValue: 'total_benefits',
                icon: 'euro',
                descriptionCallback: 'siteEconomics',
                descriptionType: 'dynamic-label',
                kpiContext: 'economics',
                description: 'widgets.savingsCard.description.default',
                devID: 'cannibal-pineapple',
                devPath: 'site->default->siteBenefitsCard',
      
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.savingsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.savingsCard.savings',
                  },
                ],
                drawerConfig: {
                  titleKey: 'drawers.siteTotalEstimatedBenefitsDrawerContent.title',
                  descriptionKey:
                    'drawers.siteTotalEstimatedBenefitsDrawerContent.description',
                  listTitleKey:
                    'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title',
                  listTitleSavingsKey:
                    'drawers.siteTotalEstimatedBenefitsDrawerContent.list_title_savings',
                },
              },
              {
                env: 'web',
                order: 2,
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pb-xs-0_5 pt-md-0 pl-md-0_5 pr-md-1 pr-lg-0_5',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteEnergyFlowsCard',
                id: 'siteEnergyFlowsCard',
                isOverview: true,
                icon: 'lightning',
                descriptionCallback: 'siteEnergy',
                descriptionType: 'siteType[label+value]',
                description: {
                  default: [
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                      value: 'consumption',
                    },
                  ],
                  consumer: [
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                      value: 'consumption',
                    },
                  ],
                  producer: [
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.production',
                      value: 'production',
                    },
                  ],
                  prosumage: [
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                      value: 'consumption',
                    },
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.production',
                      value: 'production',
                    },
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.self_consumption',
                      value: 'self_consumption',
                    },
                  ],
                  prosumer: [
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.consumption',
                      value: 'consumption',
                    },
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.production',
                      value: 'production',
                    },
                    {
                      key: 'widgets.siteEnergyFlowsCard.description.default.self_consumption',
                      value: 'self_consumption',
                    },
                  ],
                },
                devID: 'ridiculous-quokka',
                devPath: 'site->default->siteEnergyFlowsCard',
              },
              {
                env: 'web',
                order: 3,
                className: 'grid-xs-12 grid-lg-4 p-1pb-xs-0_5 pt-xs-0_5 pt-lg-0 pl-lg-0_5 pr-lg-1',
                type: 'map',
                gradientBorder: false,
                id: 'map',
                context: 'site',
                devID: 'giddy-jigsaw',
                devPath: 'site->default->map',
              },
              {
                order: 4,
                className: 'grid-xs-12 grid-lg-9 p-1 py-xs-0_5 pr-lg-0_5',
                type: 'sitePaymentsTable',
                id: 'sitePaymentsTable',
                devID: 'unruly-narwhal',
                devPath: 'site->default->sitePaymentsTable',
                showTable: false
              },
              {
                order: 5,
                id: 'parametersDetails',
                className: 'grid-xs-12 grid-xl-3 p-1 py-xs-0_5 pl-xl-0_5',
                devID: 'bendy-flower',
                items: [
                  {
                    
                    type: 'SiteDetailsParameters',
                    id: 'SiteDetailsParameters',
                    data: {
                      title: 'widgets.siteDetailsParameters.title',
                      siteName: 'widgets.siteDetailsParameters.siteName',
                      joinDate: 'widgets.siteDetailsParameters.joinDate',
                      ownership: 'widgets.siteDetailsParameters.ownership',
                      type: 'widgets.siteDetailsParameters.type',
                      productionBenefits:
                        'widgets.siteDetailsParameters.productionBenefits',
                    },
                    devID: 'treacherous-courtyard',
                    devPath: 'site->default->SiteDetailsParameters',
                  },
                  {
                    type: 'siteMembersList',
                    id: 'siteMembersList',
                    devID: 'boiling-crayon',
                    devPath: 'site->default->siteMembersList',
                  }, 
                ]
              }
              
            ],
          },
        },
      ]
    }
  },
  
];

const finalMergedConfig = mergeConfigDesktop( EON_MODULES);

export default finalMergedConfig;



